import { render, staticRenderFns } from "./CustomerPortalComponent.vue?vue&type=template&id=3a87d81e&lang=pug"
import script from "./CustomerPortalComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerPortalComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomerPortalComponent.vue?vue&type=style&index=0&id=3a87d81e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a87d81e')) {
      api.createRecord('3a87d81e', component.options)
    } else {
      api.reload('3a87d81e', component.options)
    }
    module.hot.accept("./CustomerPortalComponent.vue?vue&type=template&id=3a87d81e&lang=pug", function () {
      api.rerender('3a87d81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerPortal/CustomerPortalComponent.vue"
export default component.exports